import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { getToDoList, updateToDo, deleteToDo } from "./todoSlice";
import AddToDo from "./AddToDo";

import {MdMode, MdOutlineDelete} from "react-icons/md"

interface ToDoType {
  PK: string;
  SK: string;
  title: string;
  description?: string;
  completed: boolean;
  type: string;
}

function ToDo({ todo }: { todo: ToDoType }) {
  document.title = "Todos - To Do App";

  const [openModal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();
  const handleClick = (todo: {
    SK: string;
    title: string;
    completed: boolean;
    description?: string;
    type: "toggle"
  }) => {
    dispatch(updateToDo(todo));
  };

  const handleOpenModal = () => {
    setOpenModal(!openModal);
  };

  return (
    <div className="todo">
      {openModal && <AddToDo type="edit" todo={todo} close={handleOpenModal} />}
      <div>
        <input
          name="completed"
          type="checkbox"
          checked={todo.completed}
          onChange={(e) =>
            handleClick({
              SK: todo.SK,
              title: todo.title,
              description: todo?.description,
              completed: todo.completed,
              type: "toggle",
            })
          }
        />
        <div>
          <h3>{todo.title}</h3>
          <p>{todo.description}</p>
          <span>{new Date(parseInt(todo.SK.split("#")[2])).toUTCString()}</span>
        </div>
      </div>
      <div className="actions">
        <button onClick={handleOpenModal}>
          <MdMode />
        </button>
        <button
          style={{ color: "#ff0000" }}
          onClick={() => dispatch(deleteToDo(todo.SK))}
        >
          <MdOutlineDelete />
        </button>
      </div>
    </div>
  );
}

function ToDoList() {
  const todos = useAppSelector((state) => state.todo);
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useAppDispatch();
  const [filter, setFilter] = React.useState<
    "all" | "completed" | "uncompleted"
  >("all");

  useEffect(() => {
    if (todos.status === "idle") {
      dispatch(getToDoList());
    }
  }, [todos.status, dispatch]);

  if (todos.status === "loading") {
    return <h2>Loading...</h2>;
  }

  // const handleClick = (todo: {
  //   SK: string;
  //   title: string;
  //   completed: boolean;
  //   description?: string;
  // }) => {
  //   dispatch(updateToDo(todo));
  // };

  const handleOpenModal = () => {
    setOpenModal(!openModal);
  };
  return (
    <div className="todos">
      {todos.status === "failed" && (
        <ul className="errors-list">
          {todos.errors?.map((err, index) => (
            <li key={index}>{err}</li>
          ))}
        </ul>
      )}
      {openModal && <AddToDo type="new" close={handleOpenModal} />}
      <button className="btn-primary btn-add" onClick={handleOpenModal}>
        Add New Todo
      </button>

      <div className="list">
        <h2>ToDo List</h2>
        <div className="taps">
          <button
            className={`${filter === "all" ? "selected" : ""}`}
            onClick={() => setFilter("all")}
          >
            all
          </button>
          <button
            className={`${filter === "completed" ? "selected" : ""}`}
            onClick={() => setFilter("completed")}
          >
            completed
          </button>
          <button
            className={`${filter === "uncompleted" ? "selected" : ""}`}
            onClick={() => setFilter("uncompleted")}
          >
            uncompleted
          </button>
        </div>
        {/* <ToDos data={todos.todoList} /> */}
        {todos.todoList?.map((todo) => {
          if (filter === "all") {
            return <ToDo key={todo.SK} todo={todo} />;
          } else if (filter === "completed" && todo.completed) {
            return <ToDo key={todo.SK} todo={todo} />;
          } else if (filter === "uncompleted" && !todo.completed) {
            return <ToDo key={todo.SK} todo={todo} />;
          } else {
            return null;
          }
        })}
      </div>
    </div>
  );
}

export default ToDoList;
